module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "newsletter-area feature-area section-padding2",
    staticStyle: {
      "background-image": "url(\"static/assets/images/train/bg03.png\")",
      "background-size": "100% 100%"
    },
    attrs: {
      "id": _vm.id
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', {
    staticClass: "inputLable"
  }, [_vm._v("称呼 "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isName),
      expression: "isName"
    }],
    staticStyle: {
      "color": "rgb(127 4 4)"
    }
  }, [_vm._v("请填写内容")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.name),
      expression: "info.name"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "text",
      "placeholder": "怎么称呼您",
      "required": ""
    },
    domProps: {
      "value": (_vm.info.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', {
    staticClass: "inputLable"
  }, [_vm._v("公司 "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCompany),
      expression: "isCompany"
    }],
    staticStyle: {
      "color": "rgb(127 4 4)"
    }
  }, [_vm._v("请填写内容")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.company),
      expression: "info.company"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "text",
      "placeholder": "您的公司名称",
      "required": ""
    },
    domProps: {
      "value": (_vm.info.company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "company", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', {
    staticClass: "inputLable"
  }, [_vm._v("联系方式 "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isMobile),
      expression: "isMobile"
    }],
    staticStyle: {
      "color": "rgb(127 4 4)"
    }
  }, [_vm._v("请填写内容")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.mobile),
      expression: "info.mobile"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "text",
      "placeholder": "联系方式",
      "required": ""
    },
    domProps: {
      "value": (_vm.info.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "mobile", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "inputLable"
  }, [_vm._v("您的需求 "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDemand),
      expression: "isDemand"
    }],
    staticStyle: {
      "color": "rgb(127 4 4)"
    }
  }, [_vm._v("请填写内容")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.demand),
      expression: "info.demand"
    }],
    staticStyle: {
      "width": "100%",
      "height": "70px"
    },
    attrs: {
      "placeholder": "您想解决什么问题",
      "required": ""
    },
    domProps: {
      "value": (_vm.info.demand)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "demand", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 textCenter"
  }, [_c('button', {
    staticClass: "contactUs-btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.addBusiness
    }
  }, [_vm._v("提交")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 textCenter",
    staticStyle: {
      "height": "30px",
      "margin-top": "10px"
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOk),
      expression: "isOk"
    }]
  }, [_vm._v("提交成功")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('h2', {
    staticClass: "borderCDF"
  }, [_vm._v("联系我们")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-86d4c116"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/module/contact.vue
// module id = 103
// module chunks = 1